export default __webpack_public_path__ + "static/media/checkbox-multiple-select-prefer.a003d7cc.svg";